import StatisticsCard from './statistics-card';
import {StatisticsResponse} from "../../core/models/interfaces/statistics-dto.interface";
import React from "react";

const toPercent = (a: number, b: number): string => {
    if (!b) return '0%';
    return `${Math.round((a / b) * 100)}%`;
};

interface StatisticsGridProps {
    statistics: StatisticsResponse | null;
}

const StatisticsGrid = ({ statistics }: StatisticsGridProps) => (
    <div>
        <h1 className="text-2xl font-semibold text-on-surface mb-10 w-full">Statystyki</h1>
        <div className="grid grid-cols-3 gap-8">
            <StatisticsCard label="Wyświetlenia widżetu" value={statistics?.widgetView ?? 0} />
            <StatisticsCard label="Kliknięcia w widżet" value={statistics?.widgetClick ?? 0} />
            <StatisticsCard label="Wskaźnik interakcji" value={toPercent(statistics?.widgetClick ?? 0, statistics?.widgetView ?? 0)} />

            <StatisticsCard label="Rozpoczęte formularze" value={statistics?.formStart ?? 0} />
            <StatisticsCard label="Ukończone formularze" value={statistics?.formFinish ?? 0} />
            <StatisticsCard label="Wskaźnik ukończenia formularza" value={toPercent(statistics?.formFinish ?? 0, statistics?.formStart ?? 0)} />

            <StatisticsCard label="Przekierowania do ZnanyLekarz" value={statistics?.rediretion ?? 0} />
            <StatisticsCard label="Odwiedzone artykuły" value={statistics?.articleViews.length ?? 0} />
        </div>
    </div>
);

export default StatisticsGrid;
